import { useQuery } from '@tanstack/react-query';
import { Permission } from '@klaro7/shared-types';

import { usePermissions } from '@/features/rbac/usePermissions';
import { getFraudFlagsCount } from '../services/fraud-admin.service';

/**
 * Cluster antifrode da revisionare, per il pallino ROSSO sulla voce "Utenti"
 * in sidebar. Conta i CLUSTER (un gruppo da 5 account = 1), non gli utenti:
 * il numero resta piccolo e significativo. Stesso pattern del badge
 * questionari (staleTime 30s, refetch 60s); le mutation di revisione
 * invalidano il prefix ['fraud'].
 */
export function useFraudFlagsBadge(): number {
  const { can } = usePermissions();
  const enabled = can(Permission.ADMIN_ACCESS);

  const { data } = useQuery({
    queryKey: ['fraud', 'flags-badge'],
    queryFn: getFraudFlagsCount,
    enabled,
    staleTime: 1000 * 30,
    refetchInterval: 1000 * 60,
    // L'endpoint è super-admin only: un admin normale riceve 403 — non
    // ritentare in loop, semplicemente niente badge.
    retry: false,
  });

  return enabled ? (data?.newClusters ?? 0) : 0;
}
